import React, { useEffect } from 'react';
import { Check, CircleNotch, X } from '@phosphor-icons/react';
import { useAudioRecording } from '../../../../Hooks/useAudioRecording';
import { RootState, useAppSelector } from '../../../../store';

interface MobileRecordButtonProps {
    setNewMessage: (message: string) => void;
    newMessage: string;
    onRecordingChange: (isRecording: boolean) => void;
    onVolumeChange: (volume: number) => void;
    i18n: any;
}

const MobileRecordButton: React.FC<MobileRecordButtonProps> = ({
    setNewMessage,
    newMessage,
    onRecordingChange,
    onVolumeChange,
    i18n,
}) => {
    const settings = useAppSelector((state: RootState) => state.settings);
    const hasTranscribeModel = settings?.transcribeModel && settings.transcribeModel.trim() !== '';
    const { isRecording, isTranscribing, startRecording, cancelRecording, stopAndSendRecording } = useAudioRecording({
        onRecordingChange,
        onVolumeChange,
        setNewMessage,
        newMessage,
        enableErrorHandling: true,
    });

    useEffect(() => {
        (window as any).__mobileRecordingStart = startRecording;
        return () => {
            delete (window as any).__mobileRecordingStart;
        };
    }, [startRecording]);

    if (!hasTranscribeModel) {
        return null;
    }

    return (
        <>
            {isRecording && (
                <div className="sm:hidden flex justify-center items-center gap-4 w-full py-3 px-6 animate-in fade-in duration-200">
                    <button
                        onClick={cancelRecording}
                        className="rounded-full h-[50px] w-[50px] transition-all duration-150 
                                 text-chatInput-sendButtonColor bg-chatInput-sendButtonBackground 
                                 hover:bg-chatInput-sendButtonBackground-hover 
                                 active:scale-95 border-none flex items-center justify-center
                                 shadow-sm hover:shadow-md"
                        aria-label={i18n.translate({ id: 'cancelRecording', sourceName: 'Chat' })}
                        title={i18n.translate({ id: 'cancel', sourceName: 'Chat' })}
                    >
                        <X size={24} weight="bold" />
                    </button>
                    <button
                        onClick={stopAndSendRecording}
                        className="rounded-full h-[50px] w-[50px] transition-all duration-150 
                                 text-chatInput-sendButtonColor bg-chatInput-sendButtonBackground 
                                 hover:bg-chatInput-sendButtonBackground-hover 
                                 active:scale-95 border-none flex items-center justify-center
                                 shadow-sm hover:shadow-md"
                        aria-label={i18n.translate({ id: 'finishRecording', sourceName: 'Chat' })}
                        title={i18n.translate({ id: 'done', sourceName: 'Chat' })}
                    >
                        <Check size={24} weight="bold" />
                    </button>
                </div>
            )}

            {isTranscribing && (
                <div className="sm:hidden flex justify-center items-center w-full py-3 animate-in fade-in duration-200">
                    <div className="flex items-center gap-2 text-chatInput-textColor">
                        <CircleNotch size={20} className="animate-spin" />
                        <span className="text-sm font-medium">
                            {i18n.translate({ id: 'transcribing', sourceName: 'Chat' })}
                        </span>
                    </div>
                </div>
            )}
        </>
    );
};

export default MobileRecordButton;
